import {
    Box,
    Button,
    Typography,
    TextField,
    Grid,
    MenuItem
} from '@mui/material'
import React, { ChangeEvent, FormEvent, useState } from 'react'
import { message } from 'antd'
import axios from 'axios'
import { OneClickPayUrl } from '../../common/url'
import { isDesktop } from 'react-device-detect'
import { useTranslation } from 'react-i18next'

export const SMFindBankAccount: React.FC = () => {

    const { t } = useTranslation()

    // ======================= HOOKS
    const [step, setStep] = useState(1)

    const [forms, setForms] = useState({
        agreementNumber: '',
        vehiclePlateNumber: ''
    })

    const [financingType, setFinancingType] = useState(0)

    const financingTypeList = [t('t442'), t('t443')]

    const financingTypeSelectItem = () => (
        financingTypeList.map((item, index) => (
            financingTypeMenuItem(index)
        ))
    )

    const financingTypeMenuItem = (index: number) => {
        return (
            <MenuItem key={index} value={financingTypeList[index]} onClick={() => updateSelectFinancingType(index)}>
                {financingTypeList[index]}
            </MenuItem>
        )
    }

    const updateSelectFinancingType = (index: number) => {
        setFinancingType(index)
    }

    const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { id, value } = e.target

        setForms((prevForms) => ({
            ...prevForms,
            [id]: value,
        }))
    }

    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault()
        // alert('agreementNumber：' + forms.agreementNumber + ',plateNumber：' + forms.plateNumber)
        if (forms.agreementNumber === null || forms.agreementNumber === '') {
            message.destroy()
            message.open(
                {
                    type: 'error',
                    content: 'Agreement Number Cannot Be Blank.',
                    style: {
                        marginTop: '40vh',
                    },
                }
            )
            return
        }

        if (forms.vehiclePlateNumber === null || forms.vehiclePlateNumber === '') {
            message.destroy()
            message.open(
                {
                    type: 'error',
                    content: financingType === 0 ? 'NRIC Number Cannot Be Blank.' : 'Vehicle Plate Number Cannot Be Blank.',
                    style: {
                        marginTop: '40vh',
                    },
                }
            )
            return
        }

        var params = {}
        if (financingType === 0) {
            params = {
                'agreementNo': forms.agreementNumber,
                'nric': forms.vehiclePlateNumber
            }
        } else {
            params = {
                'agreementNo': forms.agreementNumber,
                'carPlate': forms.vehiclePlateNumber
            }
        }

        message.destroy()
        message.open({
            type: 'loading',
            content: 'loading...',
            duration: 0,
            style: {
                marginTop: '40vh',
            },
        })

        try {
            const response = await axios.post(OneClickPayUrl, params)
            if (response.status === 200) {
                const code = response.data['code']
                console.log('参数:' + JSON.stringify(response.data))
                if (code === 200) {
                    message.destroy()
                    setForms({
                        agreementNumber: '',
                        vehiclePlateNumber: ''
                    })
                    setStep(2)
                    setList1([
                        {
                            'title': 'Agreement Number',
                            'content': response.data['data']['agreementNo']
                        },
                        {
                            'title': 'Vehicle Number',
                            'content': response.data['data']['carPlate']
                        },
                        {
                            'title': 'Name',
                            'content': response.data['data']['applyName']
                        },
                    ])
                    setList2([
                        {
                            'title': 'Your UOB Bank Collection Account',
                            'content': response.data['data']['uobVA']
                        },
                        {
                            'title': 'Your AmBank Collection Account',
                            'content': response.data['data']['ambankVA']
                        },
                    ])

                } else {
                    message.destroy()
                    message.open({
                        type: 'error',
                        content: response.data['message'],
                        style: {
                            marginTop: '40vh',
                        },
                    })
                }

            }

        } catch (error) {
            message.destroy()
            message.open({
                type: 'error',
                content: 'failed',
                style: {
                    marginTop: '40vh',
                },
            })
        }
    }

    const [list1, setList1] = useState([
        {
            'title': 'Agreement Number',
            'content': ''
        },
        {
            'title': 'Vehicle Number',
            'content': ''
        },
        {
            'title': 'Name',
            'content': ''
        },
    ])

    const [list2, setList2] = useState([
        {
            'title': 'Your UOB Bank Collection Account',
            'content': ''
        },
        {
            'title': 'Your AmBank Collection Account',
            'content': ''
        },
    ])

    const renderStep2DetailItem = (title: string, content: string, key: string) => {
        return (
            <Grid key={key} item xs={12}>
                <Grid container columnSpacing={0} rowSpacing={isDesktop ? 0 : 1}>
                    <Grid item xs={isDesktop ? 6 : 12}>
                        <Typography fontSize={16} fontWeight={500} color={'#6B6B6B'}>
                            {title}
                        </Typography>
                    </Grid>
                    <Grid item xs={isDesktop ? 6 : 12}>
                        <Typography fontSize={16} fontWeight={600} color={'#141F39'}>
                            {content}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        )
    }

    const item1 = () => {
        return (
            <Box>
                <Typography fontSize={32} fontWeight={700} color={'#141F39'} paddingBottom={'48px'} textAlign={'center'}>
                    {t('t440')}
                </Typography>

                <form onSubmit={handleSubmit}>
                    <Box sx={{
                        width: '100%',
                        backgroundColor: '#FFFFFF',
                        borderRadius: '10px',
                        alignItems: 'center',
                        boxShadow: '0px 10px 80px 3px #0000001A',
                        paddingLeft: isDesktop ? '50px' : '25px',
                        paddingRight: isDesktop ? '50px' : '25px',
                        paddingTop: '50px',
                        paddingBottom: '50px',
                        justifyContent: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                    }}>
                        {/* Financing Type */}
                        <Box sx={{ width: '100%' }}>
                            <Typography fontSize={16} fontWeight={500} color={'#141F39'} paddingBottom={'12px'}>
                                {t('t441')} <span style={{
                                    color: '#FF4D49',
                                    fontSize: '16',
                                    fontWeight: '500'
                                }}>*</span>
                            </Typography>
                            <TextField
                                select
                                fullWidth
                                variant='outlined'
                                value={financingTypeList[financingType]}
                                InputProps={{
                                    style: {
                                        height: '53px',
                                    }
                                }}
                            >
                                {financingTypeSelectItem()}
                            </TextField>
                        </Box>

                        {/* Agreement Number */}
                        <Box sx={{
                            width: '100%',
                            paddingTop: '20px',
                        }}>
                            <Typography fontSize={16} fontWeight={500} color={'#141F39'} paddingBottom={'12px'}>
                                {t('t444')} <span style={{
                                    color: '#FF4D49',
                                    fontSize: '16',
                                    fontWeight: '500'
                                }}>*</span>
                            </Typography>
                            <TextField
                                fullWidth
                                placeholder=''
                                variant='outlined'
                                id='agreementNumber'
                                InputProps={{
                                    style: {
                                        height: '53px',
                                    }
                                }}
                                onChange={handleInputChange}
                            />
                        </Box>

                        {/* Last 4 NRIC Number */}
                        <Box sx={{
                            paddingTop: '20px',
                            width: '100%',
                        }}>
                            <Typography fontSize={16} fontWeight={500} color={'#141F39'} paddingBottom={'12px'}>
                                {financingType === 0 ? t('t445') : 'Vehicle Plate Number'} <span style={{
                                    color: '#FF4D49',
                                    fontSize: '16',
                                    fontWeight: '500'
                                }}>*</span>
                            </Typography>
                            <TextField
                                fullWidth
                                placeholder=''
                                variant='outlined'
                                id='vehiclePlateNumber'
                                InputProps={{
                                    style: {
                                        height: '53px',
                                    }
                                }}
                                onChange={handleInputChange}
                            />
                        </Box>

                        <Box sx={{
                            paddingTop: '40px'
                        }}>
                            <Button
                                type='submit'
                                sx={{
                                    borderRadius: '30px',
                                    height: '60px',
                                    width: '200px',
                                    // paddingLeft: '36px',
                                    // paddingRight: '36px',
                                    bgcolor: '#FFC107',
                                    border: '1px solid #FFC107',
                                    color: '#141F39',
                                    '&:hover': {
                                        bgcolor: '#FFC107',
                                    },
                                    textTransform: 'none'
                                }}
                            >
                                {t('t446')}
                            </Button>
                        </Box>
                    </Box>
                </form>
            </Box>
        )
    }

    const item2 = () => {
        return (
            <Box>
                <Typography fontSize={32} fontWeight={700} color={'#141F39'} textAlign={'center'}>
                    Bank Virtual Collection Account
                </Typography>

                <Box sx={{
                    marginTop: '48px',
                    paddingLeft: isDesktop ? '50px' : '25px',
                    paddingRight: isDesktop ? '50px' : '25px',
                    paddingTop: '50px',
                    paddingBottom: '50px',
                    backgroundColor: '#FFFFFF',
                    borderRadius: '10px'
                }}>
                    <Grid container rowSpacing={1} columnSpacing={0}>
                        {list1.map((item, index) => {
                            return renderStep2DetailItem(list1[index]['title'], list1[index]['content'], 'key:' + index)
                        })}
                    </Grid>

                    <Box sx={{
                        width: '100%',
                        height: '1px',
                        backgroundColor: '#E4E4E4',
                        marginTop: isDesktop ? '20px' : '40px',
                        marginBottom: isDesktop ? '20px' : '40px',
                    }}></Box>

                    <Grid container rowSpacing={1} columnSpacing={0}>
                        {list2.map((item, index) => {
                            return renderStep2DetailItem(list2[index]['title'], list2[index]['content'], 'key:' + index)
                        })}
                    </Grid>
                </Box>
            </Box>
        )
    }

    // ======================= VIEWS
    return (
        <Box sx={{
            width: '100%',
            backgroundColor: '#FFF8E7',
            paddingTop: '60px',
            paddingBottom: '60px',
            paddingLeft: isDesktop ? '240px' : '12px',
            paddingRight: isDesktop ? '240px' : '12px',
        }}>
            {step === 1 ? (item1()) : (item2())}
        </Box>
    )
}

// ======================= EXPORT
export default SMFindBankAccount
